import React from 'react';
import { SingleCollapse } from "@/components/";
import Indicator from './indicators';
import FollowupSubProjectPresenter from "../../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";

export interface IInstitutionalIndicators{    
    status: any;
	dataColumns: any;
    screen: string;
    projectData: any;
    saveTable: any;
    tableAlerts?: string;
    institutionalIndData: any;
    initialValidate: boolean;
}

export const InstitutionalIndicators: React.FC<IInstitutionalIndicators> = ({institutionalIndData, status, tableAlerts, dataColumns, screen, projectData, saveTable, initialValidate}: IInstitutionalIndicators) => {    
    const view: IFollowupSubproject = {
        state: {
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    const getInstitucionalIndicators = (data:any, name:string, isdDetail:boolean) => {
        if(!data?.length || !data) return <div><h6 style={{color:"rgb(240, 53, 0)"}}>{presenter.followupLabels.get("noInformationAvailable")}</h6></div>; 
        const result = data.map((indicator:any, index:number) => {
            return(
                <Indicator
                    initialValidate={initialValidate}
                    tableAlerts={tableAlerts}
					dataColumns={dataColumns}
                    indicator={indicator}
                    status={status}
                    key={index}
                    index={index}
                    screen={screen}
                    name={name}
                    isDetail={isdDetail}
                    currentYear={projectData?.year}
                    saveTable={saveTable}
                />
            );       
        });
        return result;
    }

    if(!institutionalIndData) return <></>

    return(
        <SingleCollapse
            keepOpen={!!tableAlerts} 
            idTitle="IndicatorsTourStep9" 
            idIcon="IndicatorsTourStep10" 
            title={presenter.followupLabels.get("institutionalIndicators")} 
            isOpen={(tableAlerts === "All" || initialValidate || !presenter.tourIndSeen) ? true : false} 
        >
            {getInstitucionalIndicators(institutionalIndData?.mainLine, "mainIndicator", false)}
            {getInstitucionalIndicators(institutionalIndData?.secondLine,"secondIndicator", false)}
            {getInstitucionalIndicators(institutionalIndData?.resultsIndicators, "resultsIndicators", false)}
            {getInstitucionalIndicators(institutionalIndData?.productIndicators, "productIndicators", true)}
        </SingleCollapse>
    )
}

export default InstitutionalIndicators;